'use strict';

/**
 * TEMPORARY, together with tempSetFbValidationDataDiffForAddressAndServiceAreasToFalse in
 * sites/places/server/place/conflicts.js, getConflictStats.js and locationIdsWithConflicts.js.
 *
 * Facebook address and service area conflicts cannot be resolved: Facebook accepts the update
 * but the diff remains (PinMeTo/issues#5260, reported to Facebook as bug 1927697137989489).
 * The conflict list, stats and location id queries therefore hide them for every site except
 * these. Badges and field markers must hide the same diffs, or they report conflicts the
 * conflict list never shows (PinMeTo/issues#6137).
 *
 * When Facebook fixes this, remove this helper and its callers along with the server-side
 * filters, not only the commit the conflicts.js note points to.
 */
const SITES_SHOWING_FACEBOOK_ADDRESS_CONFLICTS = ['pinmeto', 'hm'];
const HIDDEN_FACEBOOK_DIFF_KEYS = [
	'street',
	'zip',
	'city',
	'country',
	'province',
	'district',
	'serviceAreas'
];

function withoutHiddenFacebookAddressDiffs(siteName, facebookDataDiff) {
	if (!facebookDataDiff || SITES_SHOWING_FACEBOOK_ADDRESS_CONFLICTS.includes(siteName)) {
		return facebookDataDiff;
	}

	return Object.fromEntries(
		Object.entries(facebookDataDiff).map(([key, value]) =>
			HIDDEN_FACEBOOK_DIFF_KEYS.includes(key) && value?.hasDiff === true
				? [key, { ...value, hasDiff: false }]
				: [key, value]
		)
	);
}

module.exports = { withoutHiddenFacebookAddressDiffs };
